module.exports = __webpack_public_path__ + "media/images/session-background-sp-0396e4a2ce50ad7f009c31c2cdf23c7a.png";